module.exports = __webpack_public_path__ + "static/media/icon-cat-UP.27c5b88e.svg";